import type { Column } from '@/types'
import type { Document } from '@/store/parser'
import { ref } from 'vue'
import { from, scan, tap } from 'rxjs'
import { liveQuery } from 'dexie'
import { useObservable } from '@vueuse/rxjs'
import db from '@/plugins/database'
import type { DeckEvent } from '@/lib/events'

export const subscriptions = ref<Set<string>>(new Set())
// liveQuery réémet toute la table à chaque écriture : on garde l'instance précédente des documents inchangés, sinon chaque card se re-rend.
function keepUnchanged(previous: Document[], next: Document[]) {
  const byId = new Map(previous.map(d => [d.id, d]))
  return next.map(d => {
    const old = byId.get(d.id)
    return old &&
      old.revision === d.revision &&
      old.status === d.status &&
      old.published.getTime() === d.published.getTime()
      ? old
      : d
  })
}

export const documents = useObservable<Document[], []>(
  from(liveQuery(() => db.documents.toArray())).pipe(scan(keepUnchanged, [])),
  {
    initialValue: []
  }
)
export const events = useObservable<DeckEvent[], []>(
  from(liveQuery(() => db.events.toArray())),
  {
    initialValue: []
  }
)
export const columnsReady = ref(false)
export const columns = useObservable<Column[], []>(
  from(liveQuery(() => db.columns.orderBy('order').toArray())).pipe(
    tap(() => {
      columnsReady.value = true
    })
  ),
  {
    initialValue: []
  }
)
